import { Product, Category } from './storeApi';

export const mockCategories: Category[] = [
  {
    id: 1,
    name: 'Electronics',
    description: 'Electronic devices and accessories',
    image: null,
    parent: null,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 2,
    name: 'Clothing',
    description: 'Fashion and apparel',
    image: null,
    parent: null,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 3,
    name: 'Books',
    description: null,
    image: null,
    parent: null,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 4,
    name: 'Home & Kitchen',
    description: null,
    image: null,
    parent: null,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 5,
    name: 'Sports',
    description: null,
    image: null,
    parent: null,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
];

export const mockProducts: Product[] = [
  {
    id: 1,
    name: 'Smartphone',
    description: 'Latest model smartphone',
    mrp: 599.99,
    code: 'PRO-001',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 1,
        name: 'smartphone.jpg',
        image: 'https://source.unsplash.com/random/400x300/?smartphone',
        is_banner: false,
        type: 'image',
        product: 1
      }
    ],
    retailer_rate: 499.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 2,
    name: 'Laptop',
    description: 'Powerful laptop for work and gaming',
    mrp: 1299.99,
    code: 'PRO-002',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 2,
        name: 'laptop.jpg',
        image: 'https://source.unsplash.com/random/400x300/?laptop',
        is_banner: false,
        type: 'image',
        product: 2
      }
    ],
    retailer_rate: 1099.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 3,
    name: 'Wireless Headphones',
    description: 'High-quality wireless headphones with noise cancellation',
    mrp: 199.99,
    code: 'PRO-003',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 3,
        name: 'headphones.jpg',
        image: 'https://source.unsplash.com/random/400x300/?headphones',
        is_banner: false,
        type: 'image',
        product: 3
      }
    ],
    retailer_rate: 149.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 4,
    name: 'Smart Watch',
    description: 'Feature-rich smartwatch with health tracking',
    mrp: 299.99,
    code: 'PRO-004',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 4,
        name: 'smartwatch.jpg',
        image: 'https://source.unsplash.com/random/400x300/?smartwatch',
        is_banner: false,
        type: 'image',
        product: 4
      }
    ],
    retailer_rate: 199.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 5,
    name: 'Denim Jacket',
    description: 'Classic denim jacket with modern fit',
    mrp: 79.99,
    code: 'PRO-005',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 2,
    images: [
      {
        id: 5,
        name: 'denim-jacket.jpg',
        image: 'https://source.unsplash.com/random/400x300/?denim-jacket',
        is_banner: false,
        type: 'image',
        product: 5
      }
    ],
    retailer_rate: 59.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 6,
    name: 'Running Shoes',
    description: 'Comfortable running shoes with advanced cushioning',
    mrp: 129.99,
    code: 'PRO-006',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 5,
    images: [
      {
        id: 6,
        name: 'running-shoes.jpg',
        image: 'https://source.unsplash.com/random/400x300/?running-shoes',
        is_banner: false,
        type: 'image',
        product: 6
      }
    ],
    retailer_rate: 99.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 7,
    name: 'Coffee Maker',
    description: 'Programmable coffee maker with thermal carafe',
    mrp: 89.99,
    code: 'PRO-007',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 4,
    images: [
      {
        id: 7,
        name: 'coffee-maker.jpg',
        image: 'https://source.unsplash.com/random/400x300/?coffee-maker',
        is_banner: false,
        type: 'image',
        product: 7
      }
    ],
    retailer_rate: 69.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 8,
    name: 'Best-Selling Novel',
    description: 'Award-winning fiction novel',
    mrp: 24.99,
    code: 'PRO-008',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 3,
    images: [
      {
        id: 8,
        name: 'book.jpg',
        image: 'https://source.unsplash.com/random/400x300/?book',
        is_banner: false,
        type: 'image',
        product: 8
      }
    ],
    retailer_rate: 19.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 9,
    name: 'Laptop',
    description: 'High-performance laptop for work and gaming',
    mrp: 1299.99,
    code: 'PRO-009',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 9,
        name: 'laptop.jpg',
        image: 'https://source.unsplash.com/random/400x300/?laptop',
        is_banner: false,
        type: 'image',
        product: 9
      }
    ],
    retailer_rate: 1099.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 10,
    name: 'Casual T-Shirt',
    description: 'Comfortable cotton t-shirt in various colors',
    mrp: 29.99,
    code: 'PRO-010',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 2,
    images: [
      {
        id: 10,
        name: 'tshirt.jpg',
        image: 'https://source.unsplash.com/random/400x300/?tshirt',
        is_banner: false,
        type: 'image',
        product: 10
      }
    ],
    retailer_rate: 19.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 11,
    name: 'Cookbook Collection',
    description: 'Set of international cuisine cookbooks',
    mrp: 49.99,
    code: 'PRO-011',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 3,
    images: [
      {
        id: 11,
        name: 'cookbook.jpg',
        image: 'https://source.unsplash.com/random/400x300/?cookbook',
        is_banner: false,
        type: 'image',
        product: 11
      }
    ],
    retailer_rate: 39.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 12,
    name: 'Robot Vacuum',
    description: 'Smart robot vacuum with mapping technology',
    mrp: 399.99,
    code: 'PRO-012',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 4,
    images: [
      {
        id: 12,
        name: 'robot-vacuum.jpg',
        image: 'https://source.unsplash.com/random/400x300/?robot-vacuum',
        is_banner: false,
        type: 'image',
        product: 12
      }
    ],
    retailer_rate: 299.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 13,
    name: 'Yoga Mat',
    description: 'Non-slip yoga mat with carrying strap',
    mrp: 39.99,
    code: 'PRO-013',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 5,
    images: [
      {
        id: 13,
        name: 'yoga-mat.jpg',
        image: 'https://source.unsplash.com/random/400x300/?yoga-mat',
        is_banner: false,
        type: 'image',
        product: 13
      }
    ],
    retailer_rate: 29.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 14,
    name: 'Bluetooth Speaker',
    description: 'Portable waterproof bluetooth speaker',
    mrp: 79.99,
    code: 'PRO-014',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 1,
    images: [
      {
        id: 14,
        name: 'bluetooth-speaker.jpg',
        image: 'https://source.unsplash.com/random/400x300/?bluetooth-speaker',
        is_banner: false,
        type: 'image',
        product: 14
      }
    ],
    retailer_rate: 59.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 15,
    name: 'Winter Jacket',
    description: 'Warm winter jacket with removable hood',
    mrp: 149.99,
    code: 'PRO-015',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 2,
    images: [
      {
        id: 15,
        name: 'winter-jacket.jpg',
        image: 'https://source.unsplash.com/random/400x300/?winter-jacket',
        is_banner: false,
        type: 'image',
        product: 15
      }
    ],
    retailer_rate: 99.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 16,
    name: 'Air Fryer',
    description: 'Digital air fryer with multiple cooking modes',
    mrp: 129.99,
    code: 'PRO-016',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 4,
    images: [
      {
        id: 16,
        name: 'air-fryer.jpg',
        image: 'https://source.unsplash.com/random/400x300/?air-fryer',
        is_banner: false,
        type: 'image',
        product: 16
      }
    ],
    retailer_rate: 99.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 17,
    name: 'Basketball',
    description: 'Official size indoor/outdoor basketball',
    mrp: 29.99,
    code: 'PRO-017',
    is_active: true,
    base_quantity: 1,
    base_unit: 'pc',
    brand: {
      id: 1,
      name: 'TechBrand',
      image: null,
      code: 'BRD-001',
      is_active: true,
      company: 1
    },
    sub_category: 5,
    images: [
      {
        id: 17,
        name: 'basketball.jpg',
        image: 'https://source.unsplash.com/random/400x300/?basketball',
        is_banner: false,
        type: 'image',
        product: 17
      }
    ],
    retailer_rate: 19.99,
    is_quick_product: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
];
